/* OneBoutiq Catálogo — interacciones (reveal, galería, acordeón, variantes) */
(function () {
  'use strict';

  function reveal() {
    var els = [].slice.call(document.querySelectorAll('.obc-reveal'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('obc-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('obc-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('obc-in'); }); }, 1800);
  }

  function accordions() {
    document.querySelectorAll('.obc-faq__q').forEach(function (btn) {
      if (btn.dataset.obcBound) return;
      btn.dataset.obcBound = '1';
      btn.setAttribute('aria-expanded', btn.closest('.obc-faq__item').classList.contains('is-open') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var item = btn.closest('.obc-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function gallery() {
    var root = document.querySelector('[data-obc-gallery]');
    if (!root) return;
    var main = root.querySelector('[data-obc-gallery-main]');
    root.querySelectorAll('[data-obc-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full && main) main.src = full;
        root.querySelectorAll('[data-obc-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function variantSelect() {
    document.querySelectorAll('[data-obc-variant-select]').forEach(function (sel) {
      var form = sel.closest('form');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-obc-price]');
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (idInput) idInput.value = sel.value;
        if (priceEl && opt.dataset.price) priceEl.firstChild.textContent = opt.dataset.price + ' ';
        var addBtn = form.querySelector('[data-obc-add-label]');
        if (addBtn && opt.dataset.price) addBtn.textContent = 'Añadir a la bolsa · ' + opt.dataset.price;
      });
    });
  }

  function init() {
    reveal();
    accordions();
    gallery();
    variantSelect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
